<!--
/**
* @name: Add.vue
* @description: 交易管理-运费模板设置新增页面
* @author: 杨波
* @create: 2020/08/17 14:06:58
* @update: 2020/08/17 14:06:58
*/
-->

<template>
  <y-view>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <h3>离职人信息:</h3>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <span :class="css.item" v-if="baseData.name">离职业务员：{{ baseData.name }}</span>
      </y-query-item>
      <y-query-item>
        <span :class="css.item" v-if="baseData.account">账号：{{ baseData.account }}</span>
      </y-query-item>
      <y-query-item>
        <span :class="css.item" v-if="baseData.phone">手机号：{{ baseData.phone }}</span>
      </y-query-item>
      <y-query-item>
        <span :class="css.item" v-if="baseData.companyCode">所属推广公司：{{ baseData.companyName }}</span>
      </y-query-item>
      <y-query-item>
        <span :class="css.item">关联门店数：{{ baseData.shopCount }}</span>
      </y-query-item>
      <y-query-item slot="right">
        <y-button @click="submitDemission()">提交离职</y-button>
      </y-query-item>
    </y-query>
    <y-form titleAlign="right" titleWidth="100px" contentWidth="100%">
      <y-form-item title="业务交接:" required align="top">
        <ol class="ml-2">
          <li v-for="(item, index) in addPara.leaveJobList" :key="index" class="mb-1" style="list-style: decimal;">
            交接人：<Select v-model="item.transferSalesManCode" style="width: 260px;" @on-change="onChangeProgram">
              <Option v-for="(list, index) in salemanList" :value="list.code" :key="index" v-show="item.transferSalesManCode == list.code || !selectSaleManCodesArr.includes(list.code)">{{
                list.name
              }}</Option>
            </Select>
            ， 交接门店：<Select v-model="item.transferShopCodeList" filterable multiple style="width: 400px;" @on-change="onChangeShopProgram">
              <Option v-for="(vo, index) in dealersNotJoinList" v-show="!selectShopCodesArr.includes(vo.shopCode)" :value="vo.shopCode" :key="index">{{ vo.shopName }}</Option>
            </Select>

            <span class="ml-2" v-if="!isView">
              <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAddDemission"></a>&nbsp;
              <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDelete(index)" v-if="index > 0"></a>
            </span>
          </li>
        </ol>
        <div>
          <k-button type="primary" @click="onSubmitDemission" :class="css.btn" class="mt-1"> 提交交接</k-button>
        </div>
      </y-form-item>
      <y-form-item title="交接情况:" align="top">
        <span>共{{ dealersNotJoinList.length + dealersJoinList.length }}家，已交接{{ dealersJoinList.length }}，未交接{{ dealersNotJoinList.length }}</span>
      </y-form-item>
      <y-form-item title="交接关系:" align="top">
        <k-table :data="dealersJoinList" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns1()"></k-table>
      </y-form-item>
    </y-form>
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_INFO, //详情
  NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_DELETE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_SHOP_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_TRANSFER_SHOP, // 交接
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_TRANSFER_SHOP_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_DIMISSION,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  providerFeeList: [],
});
export default {
  data() {
    return {
      salemanList: [],
      dealersNotJoinList: [],
      dealersJoinList: [],
      editPara: initEditPara(),
      salesmanCode: "", //离职业务员Code
      packCell: {
        transferSalesManCode: "",
        transferShopCodeList: [],
      },
      baseData: {},
      originData: {},
      selectSaleManCodesArr: [],
      selectShopCodesArr: [],
      stId: "",
      addPara: {
        leaveJobList: [],
      },
    };
  },
  watch: {},
  methods: {
    initColumns1() {
      return [
        {
          name: "门店",
          field: "shopName",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "关联业务员",
          field: "transferSalesManName",
          style: {
            width: 180,
            padding: "1px",
            textAlign: "center",
          },
        },
      ];
    },
    getNotDealersJoinList(code) {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_SHOP_LIST,
        para: {
          salesmanCode: code,
        },
      }).then((res) => {
        this.dealersNotJoinList = res;
      });
    },
    getDealersJoinList(code) {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_TRANSFER_SHOP_LIST,
        para: {
          salesmanCode: code,
        },
      }).then((res) => {
        this.dealersJoinList = res;
      });
    },
    getSalemanList(companyCode, salesmanCode, type) {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_LIST,
        para: {
          type: type,
          companyCode: companyCode,
          excludeCodeList: [salesmanCode],
        },
      }).then((res) => {
        this.salemanList = res;
      });
    },
    onAddDemission() {
      let { tip } = this.$root;
      if (!this.addPara.leaveJobList[this.addPara.leaveJobList.length - 1].transferSalesManCode || this.addPara.leaveJobList[this.addPara.leaveJobList.length - 1].transferShopCodeList.length === 0) {
        return tip("请先完善当前交接信息");
      }
      this.addPara.leaveJobList.push(Object.assign({}, this.packCell));
    },
    onChangeProgram() {
      this.selectSaleManCodesArr = [];
      for (const item of this.addPara.leaveJobList) {
        if (item.transferSalesManCode) {
          this.selectSaleManCodesArr.push(item.transferSalesManCode);
        }
      }
    },
    onChangeShopProgram() {
      this.selectShopCodesArr = [];
      for (const item of this.addPara.leaveJobList) {
        for (const list of item.transferShopCodeList) {
          this.selectShopCodesArr.push(list);
        }
      }
    },
    submitDemission() {
      let { tip } = this.$root;
      if (this.dealersNotJoinList.length > 0) {
        let str = `该业务员还有${this.dealersNotJoinList.length}家门店未交接，请先完成交接`;
        return tip(str);
      }
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_DIMISSION,
        para: {
          salesmanCode: this.salesmanCode,
        },
      }).then((res) => {
        tip("离职成功");
        this.getDealersJoinList(this.salesmanCode);
      });
    },
    onSubmitDemission() {
      let { tip } = this.$root;
      let leaveJobList = [];
      for (let i = 0; i < this.addPara.leaveJobList.length; i++) {
        leaveJobList.push({
          transferSalesManCode: this.addPara.leaveJobList[i].transferSalesManCode,
          transferShopCodeList: this.addPara.leaveJobList[i].transferShopCodeList,
        });
      }
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_TRANSFER_SHOP,
        para: {
          salesmanCode: this.salesmanCode,
          transferInfoList: leaveJobList,
        },
      }).then((res) => {
        tip("门店交接成功");
        this.getDealersJoinList(this.salesmanCode);
        this.getNotDealersJoinList(this.salesmanCode);
        this.initPage();
      });
    },
    getDetail(code) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_INFO,
        para: { salesmanCode: code },
      })
        .then((res) => {
          this.baseData = res;
          this.getSalemanList(this.baseData.companyCode, code, this.baseData.type);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onDelete(index) {
      this.$dialog({
        title: "提示",
        content: `是否确认删除当前交接信息？`,
        ok: () => {
          this.addPara.leaveJobList.splice(index, 1);
        },
      });
    },
    initPage() {
      this.addPara.leaveJobList = [];
      Vue.lf.getItem("objSSAdd").then((d) => {
        this.addPara = Object.assign(this.addPara, d);
        this.addPara.leaveJobList.push(Object.assign({}, this.packCell));
      });
    },
  },
  created() {
    const { code } = this.$route.query;
    this.initPage();
    if (code) {
      this.getDetail(code);
      this.getNotDealersJoinList(code);
      this.getDealersJoinList(code);
      this.salesmanCode = code;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { code } = to.query;
    this.initPage();
    if (code) {
      this.getDetail(code);
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.btn {
  width: 150px;
  float: right;
  margin-left: 20px;
}
.box {
  width: 400px !important;
  min-height: 125px;
  padding: 10px;
  border: 1px solid #f0f2f5;
}
.inputW {
  width: 400px !important;
}
.input {
  width: 60px !important;
  display: inline-block !important;
  border: 1px solid #dcdfe6;
}
.label {
  color: #999 !important;
}
.item {
  font-size: 14px;
  margin-right: 14px;
}
.query {
  border-top: 1px solid rgb(227, 227, 227);
  & h3 {
    margin-top: 20px;
  }
}
</style>
